import { Collapse, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import TruestedSection from "../components/v4/TrustedSection/TruestedSection";
import LazyImage from "../components/v4/LazyLoadImage/LazyImage";

import FaqSection from "../components/v4/FaqSection/FaqSection";
import Link from "../components/v2/Link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import greenCheckCircle from "../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import detailImg2 from "../images/v4/aiSalesCrm/images/detailImg2.webp";

import heroBg from "../images/v4/aiMarketingTeams/images/heroBg.png";
import keyFeatureBackground from "../images/v4/aiMarketingTeams/images/keyFeatureBackground.png";
import supportImg from "../images/v4/aiMarketingTeams/images/supportImg.webp";
import supportBg from "../images/v4/aiMarketingTeams/images/supportBg.png";
import heroSectionImg from "../images/v4/aiMarketingTeams/images/heroSectionImg.webp";

import swiperCardBg from "../images/v4/aiSalesCrm/images/swiperCardBg.png";

import heroIcon1 from "../images/v4/aiMarketingTeams/icons/heroIcon1.svg";
import heroIcon2 from "../images/v4/aiMarketingTeams/icons/heroIcon2.svg";
import heroIcon3 from "../images/v4/aiMarketingTeams/icons/heroIcon3.svg";

import broadcastImg1 from "../images/v4/aiMarketingTeams/images/broadcastImg1.webp";
import broadcastImg2 from "../images/v4/aiMarketingTeams/images/broadcastImg2.webp";
import broadcastImg3 from "../images/v4/aiMarketingTeams/images/broadcastImg6.webp";
import broadcastImg4 from "../images/v4/aiMarketingTeams/images/broadcastImg3.webp";
import broadcastImg5 from "../images/v4/aiMarketingTeams/images/broadcastImg4.webp";

import teamsImg1 from "../images/v4/aiMarketingTeams/images/teamsImg1.webp";
import teamsImg2 from "../images/v4/aiMarketingTeams/images/teamsImg2.webp";
import teamsImg3 from "../images/v4/aiMarketingTeams/images/teamsImg3.webp";
import teamsImg4 from "../images/v4/aiMarketingTeams/images/teamsImg4.webp";

import realWorldImg1 from "../images/v4/aiMarketingTeams/images/realWorldImg1.webp";
import realWorldImg2 from "../images/v4/aiMarketingTeams/images/realWorldImg2.webp";
import realWorldImg3 from "../images/v4/aiMarketingTeams/images/realWorldImg3.webp";
import realWorldImg4 from "../images/v4/aiMarketingTeams/images/realWorldImg4.webp";
import realWorldImg5 from "../images/v4/aiMarketingTeams/images/realWorldImg5.webp";

import cardImg1 from "../images/v4/aiMarketingTeams/images/cardImg1.webp";
import cardImg2 from "../images/v4/aiMarketingTeams/images/cardImg2.webp";
import cardImg3 from "../images/v4/aiMarketingTeams/images/cardImg3.webp";
import cardImg4 from "../images/v4/aiMarketingTeams/images/cardImg4.webp";
import cardImg5 from "../images/v4/aiMarketingTeams/images/cardImg5.webp";
import cardImg6 from "../images/v4/aiMarketingTeams/images/cardImg6.webp";

import partnerIcon1 from "../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../images/v4/aiPage/icons/partnerIcon8.png";

import SEO from "../components/SEO";
import CardAccordian from "../components/v4/cardAccordians/CardAccordian";

const useStyles = makeStyles(() => ({
  heroContainer: {
    backgroundImage: `url(${heroBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
  heroSection: {
    paddingTop: "100px",
    "@media only screen and (max-width: 600px)": {
      paddingTop: "0",
    },
  },
  heroSectionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "50px",
    },
  },
  leftContainer: {
    width: "50%",
    gap: "16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  leftBody: {
    gap: "16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    "& span": {
      background: "linear-gradient(90deg, #CD8FFF 0%, #FFC5AD 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
  },
  rightContainer: {
    width: "50%",
    display: "flex",
    alignItems: "stretch",
    justifyContent: "flex-start",
    gap: "24px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      display: "none",
    },
  },

  boxes: {
    marginTop: "40px",
    width: "100%",
    display: "flex",
    gap: "24px",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      flexWrap: "wrap",
      gap: "12px",
    },
  },
  box: {
    width: "32%",
    gap: "12px",
    padding: "16px",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(50px)",
    "& p": {
      textAlign: "center",
      width: "80%",
    },
    "&:first-child": {
      background: "#0A2F50",
    },
    "&:nth-child(2)": {
      background: "#1a234b",
    },
    "&:last-child": {
      background: "#3b1657",
    },
    "@media only screen and (max-width: 600px)": {
      flex: "1",
      padding: "10px",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: "20px",
    },
  },
  stripSection: {
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  supportBox: {
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "#0e314d",
    backgroundImage: `url(${supportBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column-reverse",
      width: "100%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
      "& $cardPointer": {
        alignItems: "center",
      },
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "55%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  bentoSection: {
    // background: "#210438",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "100%",
      gap: "24px",
    },
    "& .bentoSection": {
      marginTop: "60px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "100%",
      gap: "24px",
    },

    "& .bentoCard": {
      padding: "20px",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      width: "55%",
      gap: "24px",
      "& .cardDetails": {
        gap: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100% !important",
      },
    },
    "& .card1": {
      paddingBottom: "0",
      background: "linear-gradient(90deg, #2576BB 0%, #0A2F4F 100%)",
      "& img": {
        width: "100%",
      },
    },
    "& .card2": {
      width: "45%",
      flexDirection: "row",
      background: "linear-gradient(90deg, #783CA8 0%, #F48446 100%)",
      "@media only screen and (max-width: 600px)": {
        alignItems: "center",
      },
      "& .cardDetails": {
        width: "40%",
        "@media only screen and (max-width: 600px)": {
          width: "70%",
        },
      },
      "& img": {
        width: "40%",
        "@media only screen and (max-width: 600px)": {
          width: "40%",
        },
      },
    },
    "& .card3": {
      flexDirection: "row",
      background: "linear-gradient(90deg, #053333 0%, #009A99 100%)",
      "@media only screen and (max-width: 600px)": {
        alignItems: "center",
      },
      "& .cardDetails": {
        width: "60%",
        "@media only screen and (max-width: 600px)": {
          width: "70%",
        },
      },
      "& img": {
        width: "33%",
        "@media only screen and (max-width: 600px)": {
          width: "40%",
        },
      },
    },
    "& .card4": {
      flexDirection: "row",
      background: "linear-gradient(90deg, #09939A 0%, #783CA8 100%)",
      "& .cardDetails": {
        width: "60%",
      },
      "& img": {
        width: "25%",
        "@media only screen and (max-width: 600px)": {
          width: "30%",
        },
      },
    },
    "& .card5": {
      background: "linear-gradient(90deg, #2788E7 0%, #783CA8 100%)",
    },
    "& .bentoUpperSection": {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "stretch",
      width: "100%",
      gap: "24px",
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
      },
    },
    "& .bentoLowerSection": {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "stretch",
      width: "100%",
      gap: "24px",
      "& .card3": {
        width: "39%",
      },
      "& .card4": {
        width: "35%",
      },
      "& .card5": {
        width: "24%",
      },
      "& .cardDetails": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "16px",
      },
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
      },
    },
  },
  detailSection: {
    // background: "#210538",
  },
  detailCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column-reverse",
      gap: "40px",
    },
  },
  detailCardLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "20px",
    width: "38%",
    "&.card2": {
      width: "48%",
      backgroundRepeat: "no-repeat",
      backgroundImage: `url(${swiperCardBg})`,
      backgroundSize: "auto",
      backgroundPosition: "top",
      padding: "20px 20px 0",
      flexWrap: "wrap",
      flexDirection: "row",
      borderRadius: "16px 16px 0 0",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "&.card2": {
        width: "100%",
      },
    },
  },
  detailCardRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "20px",
    width: "48%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "-20%",
    "@media only screen and (max-width: 600px)": {
      top: "-15%",
    },
  },
  tabsSection: {
    position: "relative",
    background: "#E0EFFD",
    paddingTop: "300px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "120px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "65px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "auto",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },

  tabListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  tabListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  tabListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  broadcastContainer: {
    backgroundImage: `url(${keyFeatureBackground})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "78%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $broadcastRightContainer": {
      width: "40%",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
      "& $broadcastRightContainer": {
        width: "100%",
      },
    },
  },
  workflowBroadcastContainerInner: {
    width: "100%",
    display: "flex",
    position: "relative",
    alignItems: "stretch",
    gap: "30px",
    padding: "0 4rem 4rem !important",
    overflow: "auto",
    justifyContent: "flex-start",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0 15px 40px !important",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "0 19rem 6rem !important",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  broadcastBox: {
    display: "flex !important",
    padding: "0",
    background: "#009249",
    alignItems: "stretch",
    borderRadius: "20px",
    justifyContent: "space-between",
    minWidth: "75%",
    maxWidth: "75%",
    minHeight: "415px",
    maxHeight: "415px",
    transition: "0.3s ease",
    overflow: "hidden",
    "& $broadcastLeftContainer": {
      width: "40%",
      minWidth: "40%",
      padding: "40px",
    },
    "& $broadcastRightContainer": {
      width: "auto",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "flex-end",
    },
    "&.active": {
      transform: "scale(1) !important",
    },
    "&.inActive": {
      transform: "scale(0.8) !important",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0",
      gap: "15px",
      flexDirection: "column",
      minHeight: "500px",
      justifyContent: "space-between",
      minWidth: "100%",
      maxWidth: "100%",
      "& $broadcastLeftContainer": {
        gap: "15px",
        width: "auto",
        padding: "15px",
      },
      "& $broadcastRightContainer": {
        width: "100%",
      },
    },
  },
  commonPageFooterSection: {
    background:
      " linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  commonBgSection: {
    paddingBottom: "170px",
    background: "linear-gradient(180deg, #210538 75%, #782CB5 100%);",
    // backgroundImage: `url(${aiMarketingBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
}));

const BestAiCrmForMarketingTeams = () => {
  const classes = useStyles();
  const [activeRealWorld, setActiveRealWorld] = useState(0);

  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];

  const broadcastList = [
    {
      heading: "AssistAI content engine",
      content:
        "Create engaging replies, rephrase emails, and match your brand tone in seconds. AssistAI helps your team respond faster and sound smarter—every time.",
      img: broadcastImg1,
      alt: "AI content engine for marketing",
      background: "linear-gradient(270deg, #011C33 0.17%, #208EEC 99.83%)",
    },
    {
      heading: "Omnichannel lead capture",
      content:
        "Auto-capture leads from TikTok Ads, WhatsApp, Instagram, and more. With one unified inbox, your team never misses a prospect.",
      img: broadcastImg2,
      alt: "Omnichannel lead capture",
      background: "linear-gradient(270deg, #053333 0.17%, #009A99 99.83%)",
    },
    {
      heading: "Campaign automation workflows",
      content:
        "Automate drip campaigns, bulk-send messages, and schedule outreach across channels using prebuilt templates or your own media-rich content.",
      img: broadcastImg4,
      alt: "Campaign automation workflows",
      background: "linear-gradient(270deg, #210538 0.17%, #9E5AD5 99.83%)",
    },
    {
      heading: "AI insights and summaries",
      content:
        "Extract summaries, questions, and keywords from conversations. Use these insights to fine-tune your campaigns and personalise your messaging.",
      img: broadcastImg5,
      alt: "AI insights and summaries",
      background: "linear-gradient(270deg, #003640 -0.8%, #028BA6 100%)",
    },
    {
      heading: "Performance dashboards",
      content:
        "Track campaign performance, engagement rates, and team activity with easy-to-read dashboards. Get actionable data to improve your strategy.",
      img: broadcastImg3,
      alt: "Visual performance dashboards",
      background: "linear-gradient(270deg, #2788E7 0%, #783CA8 100%)",
    },
  ];

  const tabContentData = [
    {
      tabContent: [
        {
          title: "Cart recovery workflows",
          content:
            "Detect abandoned carts and auto-trigger WhatsApp or email reminders.",
          alt: "AI CRM for E-commerce Marketing",
        },
        {
          title: "Product recommendations",
          content:
            "Push tailored product suggestions based on past chats or purchase history.",
          alt: "AI CRM for E-commerce Marketing",
        },
        {
          title: "Campaign retargeting",
          content:
            "Use AI scoring to retarget high-intent users with relevant offers.",
          alt: "AI CRM for E-commerce Marketing",
        },
        {
          title: "Upsell opportunities",
          content:
            "Suggest complementary products right from the CRM dashboard.",
          alt: "AI CRM for E-commerce Marketing",
        },
      ],
      img: realWorldImg1,
      alt: "AI CRM for E-commerce Marketing",
      subtitle:
        "Increase conversions and retention with faster, AI-automated engagement.",
    },

    {
      tabContent: [
        {
          title: "Lead capture automation",
          content:
            "Auto-import form fills and chatbot queries from multiple ad platforms.",
          alt: "AI CRM for Education",
        },
        {
          title: "Class reminders",
          content:
            "Send timely updates via WhatsApp or SMS for demo classes or webinars.",
          alt: "AI CRM for Education",
        },
        {
          title: "Drip nurturing",
          content:
            "Guide students through onboarding using scheduled, AI-personalised sequences.",
          alt: "AI CRM for Education",
        },
        {
          title: "Feedback loops",
          content:
            "Collect and analyse sentiment from student queries in real time.",
          alt: "AI CRM for Education",
        },
      ],
      img: realWorldImg2,
      alt: "AI CRM for Education",
      subtitle: "Simplify student acquisition, nurturing, and re-engagement.",
    },
    {
      tabContent: [
        {
          title: "Instant inquiry response",
          content:
            "Auto-send brochures, floor plans, or pricing via WhatsApp on lead capture.",
          alt: "AI CRM for Real Estate",
        },
        {
          title: "Visit scheduling",
          content:
            "Let prospects book property tours through AI-enabled chatbots.",
          alt: "AI CRM for Real Estate",
        },
        {
          title: "Lead scoring",
          content:
            "Use AI to highlight high-value leads based on budget, location, and engagement.",
          alt: "AI CRM for Real Estate",
        },
        {
          title: "Broker coordination",
          content: "Auto-assign leads and follow-ups to relevant agents.",
          alt: "AI CRM for Real Estate",
        },
      ],
      img: realWorldImg3,
      alt: "AI CRM for Real Estate",
      subtitle:
        "Streamline high-ticket lead engagement with smart CRM workflows.",
    },
    {
      tabContent: [
        {
          title: "Lead capture automation",
          content:
            "Auto-import form fills and chatbot queries from multiple ad platforms.",
          alt: "AI CRM for B2B SaaS Marketing",
        },
        {
          title: "Class reminders",
          content:
            "Send timely updates via WhatsApp or SMS for demo classes or webinars.",
          alt: "AI CRM for B2B SaaS Marketing",
        },
        {
          title: "Drip nurturing",
          content:
            "Guide students through onboarding using scheduled, AI-personalised sequences.",
          alt: "AI CRM for B2B SaaS Marketing",
        },
        {
          title: "Feedback loops",
          content:
            "Collect and analyse sentiment from student queries in real time.",
          alt: "AI CRM for B2B SaaS Marketing",
        },
      ],
      img: realWorldImg4,
      alt: "AI CRM for B2B SaaS Marketing",
      subtitle: "Speed up the marketing-to-sales handoff with AI.",
    },
    {
      tabContent: [
        {
          title: "Appointment follow-ups",
          content: "Send pre- and post-consultation updates via WhatsApp.",
          alt: "AI CRM for Healthcare",
        },
        {
          title: "Service discovery",
          content:
            "Recommend treatments or services using AI chat suggestions.",
          alt: "AI CRM for Healthcare",
        },
        {
          title: "Seasonal campaigns",
          content:
            "Launch health awareness campaigns with scheduled automation.",
          alt: "AI CRM for Healthcare",
        },
        {
          title: "Feedback collection",
          content: "Use AI to summarise sentiment from patient messages.",
          alt: "AI CRM for Healthcare",
        },
      ],
      img: realWorldImg5,
      alt: "AI CRM for Healthcare",
      subtitle:
        "Build trust and engage patients or clients with timely, informative messaging.",
    },
  ];

  const faqs = [
    {
      question: "How is Pepper Cloud different from other CRMs?",
      answer:
        "Pepper Cloud is an AI-first CRM designed for SMEs. It supports multiple channels, automates responses, and uses AI to help you personalise and scale your marketing.",
    },
    {
      question: "Can I connect my social media ads to the CRM?",
      answer:
        "Yes. You can auto-sync leads from TikTok Ads, Facebook, Instagram, and WhatsApp into your CRM.",
    },
    {
      question: "Do I need coding skills to use automation?",
      answer:
        "Not at all. Pepper Cloud offers no-code workflows, making it simple for any marketing team to set up automations.",
    },
    {
      question: "Can the AI write my replies?",
      answer:
        "Yes. AssistAI can generate smart, tone-matched replies, summarise messages, and rephrase responses instantly.",
    },
    {
      question: "Is Pepper Cloud suitable for small teams?",
      answer:
        "Absolutely. It’s designed to help small and mid-sized teams save time and grow faster with AI tools.",
    },
  ];

  const cardsData = [
    {
      alt: "AI CRM for marketing teams",
      img: cardImg1,
      background: "#002A4E",
      title: "Always-on campaign execution",
      text: "Run marketing campaigns even while you sleep. With AI-driven scheduling and follow-ups, Pepper Cloud ensures your outreach never stops—perfect for time-sensitive or global campaigns.",
    },
    {
      alt: "AI CRM for marketing teams",
      img: cardImg2,
      background: "#00315B",
      title: "Real-time lead intelligence",
      text: "Gain instant context on every lead—view behaviour patterns, recent interactions, and AI-generated scores. Your team knows who to contact, when, and why.",
    },
    {
      alt: "AI CRM for marketing teams",
      img: cardImg3,
      background: "#003A6C",
      title: "Reduced manual work",
      text: "Say goodbye to repetitive tasks like email sorting or form imports. AI automates list creation, tagging, and even follow-up triggers—freeing up your marketers to focus on strategy.",
    },
    {
      alt: "AI CRM for marketing teams",
      img: cardImg4,
      background: "#004783",
      title: "Personalisation at scale",
      text: "Create dynamic, tailored messages for each audience segment. Pepper Cloud helps you send relevant, human-like communications without rewriting every message manually.",
    },
    {
      alt: "AI CRM for marketing teams",
      img: cardImg5,
      background: "#005299",
      title: "Improved ROI tracking",
      text: "Understand which campaigns perform best, and why. AI-backed insights help you attribute results accurately, optimise spend, and double down on what’s working.",
    },
    {
      alt: "AI CRM for marketing teams",
      img: cardImg6,
      background: "#0063B8",
      title: "Stronger team collaboration",
      text: "With shared inboxes, automated task assignments, and campaign history in one place, your marketing team stays aligned—even across channels and campaigns.",
    },
  ];

  return (
    <main>
      <SEO
        title={"Best AI CRM for Marketing Automation | Pepper Cloud"}
        pathname={"https://peppercloud.com/ai-crm-for-marketing-automation/"}
        keywords="crm for marketing,best crm for marketing automation,crm automation software,using crm for marketing,crm for marketing automation"
        description={
          "Discover the best CRM for marketing automation. Capture leads, run campaigns, and engage customers with Pepper Cloud’s AI-powered CRM software. Automate campaigns, personalise outreach, and boost ROI with Pepper Cloud’s AI CRM for marketing. Smart automation, omnichannel, and AI insights."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "How is Pepper Cloud different from other CRMs?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud is an AI-first CRM designed for SMEs. It supports multiple channels, automates responses, and uses AI to help you personalise and scale your marketing.",
                },
              },
              {
                "@type": "Question",
                name: "Can I connect my social media ads to the CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. You can auto-sync leads from TikTok Ads, Facebook, Instagram, and WhatsApp into your CRM.",
                },
              },
              {
                "@type": "Question",
                name: "Do I need coding skills to use automation?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Not at all. Pepper Cloud offers no-code workflows, making it simple for any marketing team to set up automations.",
                },
              },
              {
                "@type": "Question",
                name: "Can the AI write my replies?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. AssistAI can generate smart, tone-matched replies, summarise messages, and rephrase responses instantly.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud suitable for small teams?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. It’s designed to help small and mid-sized teams save time and grow faster with AI tools.",
                },
              },
            ],
          },
        ]}
      />
      <div className={classes.heroContainer}>
        <section className={classes.heroSection}>
          <div className="container">
            <div className={classes.heroSectionContainer}>
              <div className={classes.leftContainer}>
                <div className={classes.leftBody}>
                  <motion.h1
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-wix-semibold font-64 font-white"
                  >
                    Best AI CRM for <span>marketing teams</span>
                  </motion.h1>
                  <p className="font-white font-20 font-wix-regular mb20">
                    Blast marketing campaigns, engage smarter, and drive ROI
                    with Pepper Cloud AI-powered CRM built for fast-moving
                    marketing teams. One smart platform. All your channels. Full
                    AI assistance.
                  </p>
                  <Link
                    className="primaryButton font-20 font-wix-medium font-white "
                    to="/contact/"
                  >
                    Book a free demo
                  </Link>
                  <div className={classes.boxes}>
                    <div className={classes.box}>
                      <img src={heroIcon1} />
                      <p className="font-18 font-wix-medium font-white">
                        Message broadcast
                      </p>
                    </div>
                    <div className={classes.box}>
                      <img src={heroIcon2} />
                      <p className="font-18 font-wix-medium font-white">
                        Automated messaging 
                      </p>
                    </div>
                    <div className={classes.box}>
                      <img src={heroIcon3} />
                      <p className="font-18 font-wix-medium font-white">
                        AI-driven insights
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.rightContainer}>
                <LazyImage source={heroSectionImg} width={"100%"} />
              </div>
            </div>
          </div>
        </section>
        <section className={classes.stripSection}>
          <div className="container">
            <div className="centerContainer">
              <motion.h3
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-24 font-white"
              >
                Trusted by leading businesses for outstanding efficiency
              </motion.h3>
            </div>
          </div>
          <Swiper
            className={classes.partnerSlider}
            slidesPerView="auto"
            spaceBetween={60}
            loop={true}
            speed={3000}
            modules={[Autoplay]}
            allowTouchMove={false}
            autoplay={{
              delay: 100,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            breakpoints={{
              // For smaller screens (mobile)
              0: {
                freeMode: true,
                grabCursor: false,
                allowTouchMove: true,
                spaceBetween: 20,
              },
              // For larger screens (desktop)
              768: {
                freeMode: false,
                autoplay: {
                  delay: 100,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                },
                speed: 3000,
                loop: true,
                allowTouchMove: true,
              },
            }}
          >
            {partners.map((partner) => (
              <SwiperSlide className={classes.partnerSlide}>
                <img src={partner.icon} alt={partner.alt} />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="container containerInner">
            <motion.div
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className={classes.supportBox}
              // style={{ background: point.background }}
            >
              <div className={classes.broadcastRightContainer}>
                <LazyImage
                  source={supportImg}
                  width={"100%"}
                  alt={"What is AI CRM for marketing teams?"}
                  className={classes.broadcastImg}
                />
              </div>
              <div className={classes.broadcastLeftContainer}>
                <p className={clsx("font-40 font-wix-medium font-white")}>
                  What is AI CRM for marketing teams?
                </p>
                <p className="font-18 font-wix-regular font-white">
                  An AI CRM for marketing teams helps you manage leads, automate
                  campaigns, and personalise communication using artificial
                  intelligence. Unlike traditional CRMs, it understands your
                  customer interactions, highlights what matters, and helps you
                  take action faster.
                </p>
                <p className="font-18 font-wix-regular font-white">
                  At Pepper Cloud, AI isn’t just a feature. It powers your
                  entire marketing workflow—from capturing leads on social media
                  to writing follow-up messages. So your team spends less time
                  on busywork and more on driving results.
                </p>
              </div>
            </motion.div>
          </div>
        </section>
      </div>
      <section className={classes.broadcastContainer}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-black1"
            >
              Key features: AI CRM for marketing
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-20 font-black1"
            >
              Built for high-impact marketing teams, Pepper Cloud’s AI CRM
              combines automation, personalisation, and multichannel engagement
              into one smart platform.
            </motion.p>
          </div>
        </div>
        <Swiper
          slidesPerView={1}
          centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          className={classes.workflowBroadcastContainerInner}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 10,
              centeredSlides: false,
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: "auto",
              centeredSlides: true,
              spaceBetween: 30,
              grabCursor: true,
            },
          }}
        >
          {broadcastList.map((point, index) => (
            <SwiperSlide
              className={classes.broadcastBox}
              style={{ background: point.background }}
            >
              <div className={classes.broadcastLeftContainer}>
                <p className="font-40 font-wix-medium font-white">
                  {point.heading}
                </p>
                <p className="font-18 font-wix-medium font-white">
                  {point.content}
                </p>
              </div>
              <div className={classes.broadcastRightContainer}>
                <img
                  src={point.img}
                  alt={point.alt}
                  className={classes.broadcastImg}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.commonBgSection}>
        <section className={classes.bentoSection}>
          <div className="container">
            <div className="centerContainer">
              <motion.h2
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-56 font-white"
              >
                Pepper Cloud: The best AI CRM for marketing teams
              </motion.h2>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-20 color-black7"
              >
                Pepper Cloud blends Generative AI, Assistive AI, and
                Conversational AI to deliver a purpose-built CRM for modern
                marketing teams. It helps you plan smarter campaigns,
                personalise outreach at scale, and convert faster, without
                switching tools or losing momentum.
              </motion.p>
            </div>
            <div className="bentoSection">
              <div className="bentoUpperSection">
                <div className="bentoCard card1">
                  <div className="cardDetails">
                    <h3 className="font-20 font-white font-wix-bold">
                      Designed to grow with you
                    </h3>
                    <p className="font-16 font-white font-wix-regular">
                      Whether you are launching your first ad or scaling global
                      outreach, Pepper Cloud adapts. Auto-capture users and have
                      numerous touchpoints—without performance limits or hidden
                      charges.
                    </p>
                  </div>

                  <img src={teamsImg1} alt="AI CRM for marketing teams" />
                </div>
                <div className="bentoCard card2">
                  <div className="cardDetails">
                    <h3 className="font-20 font-white font-wix-bold">
                      AI woven into every workflow
                    </h3>
                    <p className="font-16 font-white font-wix-regular">
                      All AI features are built directly into the platform. From
                      drafting emails to scoring leads, your team works smarter
                      within the CRM—no add-ons, no toggling between tools.
                    </p>
                  </div>
                  <img src={teamsImg2} alt="AI CRM for marketing teams" />
                </div>
              </div>
              <div className="bentoLowerSection">
                <div className="bentoCard card3">
                  <img src={teamsImg3} alt="AI CRM for marketing teams" />
                  <div className="cardDetails">
                    <h3 className="font-20 font-white font-wix-bold">
                      Multichannel mastery made simple
                    </h3>
                    <p className="font-16 font-white font-wix-regular">
                      Connect with leads across WhatsApp, TikTok, email, and
                      more—all from a shared inbox. Manage every marketing
                      conversation in one seamless flow.
                    </p>
                  </div>
                </div>
                <div className="bentoCard card4">
                  <img src={teamsImg4} alt="AI CRM for marketing teams" />
                  <div className="cardDetails">
                    <h3 className="font-20 font-white font-wix-bold">
                      Complete marketing automation:
                    </h3>
                    <p className="font-16 font-white font-wix-regular">
                      Schedule and send broadcasts, respond instantly to
                      customers' messages with AI chatbot, auto-send follow-ups,
                      and more.
                    </p>
                  </div>
                </div>
                <div className="bentoCard card5">
                  <div className="cardDetails">
                    <h3 className="font-20 font-white font-wix-bold">
                      Real-time insights that drive ROI
                    </h3>
                    <p className="font-16 font-white font-wix-regular">
                      Gain live recommendations, performance alerts, and
                      audience trends as your campaigns run. Pepper Cloud keeps
                      your team agile and ahead of the curve.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={classes.detailSection}>
          <div className="container">
            <div className={classes.detailCard}>
              <div className={classes.detailCardLeft}>
                <LazyImage
                  width={"100%"}
                  source={detailImg2}
                  alt="AI CRM for marketing teams"
                />
              </div>
              <div className={classes.detailCardRight}>
                <motion.p
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="font-wix-semibold font-20 font-white"
                >
                  AssistAI
                </motion.p>
                <motion.h2
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="font-wix-semibold font-56 font-white"
                >
                  One system, endless smart actions
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                  className="font-wix-regular font-18 font-white"
                >
                  From sentiment tagging to workflow triggers, let AI handle the
                  repetitive stuff. You focus on decisions — your CRM takes care
                  of the data.
                </motion.p>
              </div>
            </div>
          </div>
        </section>
        <CardAccordian
          light
          heading={"Benefits of AI CRM for marketing teams"}
          cardsData={cardsData}
        />
      </div>
      <section className={classes.tabsSection}>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow={true} background={true} />
        </div>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Application and use cases of AI CRM for marketing teams
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-20 color-black1"
            >
              AI CRM is transforming how marketing teams engage audiences,
              capture leads, and optimise campaign outcomes. With Pepper Cloud’s
              intelligent marketing CRM, you can automate outreach, personalise
              messaging, and manage every channel from one unified space.
            </motion.p>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                E-commerce
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Education
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Real estate
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                B2B SaaS marketing
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 4 && "active"
                )}
                onClick={() => setActiveRealWorld(4)}
              >
                Healthcare
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 font-black1"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.tabListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.tabListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.tabIcon}
                              alt={item.alt}
                            />
                            <div className={classes.tabListItemContent}>
                              <p className="font-wix-semibold font-18 font-black1">
                                {item.title}:
                              </p>
                              <p className="font-wix-regular font-18 font-black1">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt={listItem.alt}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFFFFF"}
          heading={"Frequently asked questions - AI CRM for marketing teams"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Promote products and connect with customers using AI CRM
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default BestAiCrmForMarketingTeams;
